<template>
  <div class="w-100">
    <v-card v-if="event && !loading && !getReported && (showBlocked || !getBlocked)" class="mb-4 event-card"
      width="100%">
      <v-menu offset-y rounded="lg" left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon style="position: absolute; right: 3px; top: 23px" v-bind="attrs" v-on="on" class="menu-btn">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in dropMenus" v-on:change="onSelectedMenu(item)" :key="index" link>
            <v-list-item-title class="mr-3">
              <v-icon class="mr-3">{{ item.icon }}</v-icon>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-card-title class="flex-row d-flex mr-9 avatar-event-icon" style="align-items: flex-start">
        <div :class="avatarClasses" :style="avatarStyles">
          <img v-if="event.poster.thumbnail" :src="event.poster.thumbnail
            ? event.poster.thumbnail
            : event.poster.image
            " :alt="name" class="avatar-img" />
          <img v-else :src="require('@/assets/default.jpg')" :alt="name" class="avatar-img" />
          <!-- Lock overlay for private accounts -->
          <div v-if="isPosterPrivate && event.poster.type === 'Volunteer'" class="lock-overlay">
            <v-icon color="white" size="20">mdi-lock</v-icon>
          </div>
        </div>
        <editable-avatar :image="event.poster.thumbnail ? event.poster.thumbnail : event.poster.image
          " :editable="false" :size="$vuetify.breakpoint.xs ? 40 : 50" class="mr-5 d-none" />
        <!-- <div class="d-flex flex-column" style="margin-top: 7px">
          <span
            v-text="event.poster.name"
            class="url-button font-weight-bold"
            :style="
              $vuetify.breakpoint.xs
                ? 'font-size: 18px; line-height: 20px;'
                : 'font-size: 20px; line-height: 22px;'
            "
            @click="goToProfile(event.poster._id, event.poster.type)"
          />
          <span
            :style="
              $vuetify.breakpoint.xs
                ? 'line-height: 14px; font-size: 10px; margin-top: 2px;'
                : 'line-height: 16px; font-size: 12px; margin-top: 2px; color: gray;'
            "
            v-text="getTimeAgo(event.createdAt)"
          />
        </div> -->
        <!-- <div class="d-flex flex-row align-center justify-space-between" style="width: 100%; margin-top: 7px"> -->
        <div class="d-flex flex-column" style="flex: 1; min-width: 0;">
          <!-- Added min-width: 0 for truncation -->
          <span class="url-button font-weight-bold truncate-text" :style="$vuetify.breakpoint.xs
            ? 'font-size: 18px; line-height: 20px;'
            : 'font-size: 20px; line-height: 22px;'"
            @click="handlePosterClick">
            {{ event.poster.name }}
            <!-- Lock icon ONLY for Volunteers -->
            <v-icon v-if="isPosterPrivate && event.poster.type === 'Volunteer'" small color="grey" class="ml-1">
              mdi-lock
            </v-icon>
          </span>
          <span :style="$vuetify.breakpoint.xs
            ? 'line-height: 14px; font-size: 10px; margin-top: 2px;'
            : 'line-height: 16px; font-size: 12px; margin-top: 2px; color: gray;'
            " v-text="getTimeAgo(event.createdAt)" />
        </div>

        <div class="action-item donate-item" v-if="event.category !== 'Individual'" @click="donate">
          <v-icon size="20">mdi mdi-currency-usd</v-icon>
          <span class="action-label actn-label-donate">Donate</span>
        </div>
        <!-- </div> -->

        <!-- && event.points && (event.poster._id === profile._id && event.points.highestAgency.agencyId === profile._id) -->
        <!-- <v-btn
          v-if="event.category !== 'Individual'"
          color="primary"
          @click="donate"
          class="donate-btn"
          dark
        >
          Donate
        </v-btn> -->
        <!-- <v-btn
            v-if="event.category != 'Individual'"
            color="primary"
            @click="donate"
            class="px-4 event-card__donate-btn text-none"
            rounded
            small
            elevation="1"
          >
            <v-icon left size="18">mdi-heart</v-icon>
            Donate
          </v-btn> -->
      </v-card-title>

      <!-- <v-card-text
        v-if="event.text && event.text.length > 10"
        class="pb-0 event-text"
        style="position: relative"
      >
        <span
          class="text-block"
          v-if="text_collapsed"
          v-linkified
          v-text="collapsed_text"
        />
        <span v-else v-text="event.text" class="text-block" v-linkified />
        <span
          class="url-button"
          @click="text_collapsed = !text_collapsed"
          x-small
          style="position: absolute; right: 18px; bottom: 0; background: white"
        >
          {{ text_collapsed ? "...see more" : "see less" }}
        </span>
      </v-card-text>
      <v-card-text v-else class="pb-0 event-text" style="position: relative">
        <span v-text="event.text" class="text-block" v-linkified />
      </v-card-text> -->

      <!-- Points Display (for non-individual events) -->

      <v-hover v-slot:default="{ hover }">
        <div class="modern-competition-card">


          <div v-if="event.category === 'Competition' && event.points" class="modern-points-card"
            :class="{ 'modern-points-card-hover': hover }">
            <p class="modern-competition-title" v-if="event.category === 'Competition'">
              <!-- <span class="title-text">
    {{
      event.competitionData && event.competitionData.title
        ? (event.competitionData.title.length > 30
            ? event.competitionData.title.slice(0, 30) + '...'
            : event.competitionData.title)
        : ''
    }}
  </span> -->
              <span class="title-text">
                {{
                  event.competitionData && event.competitionData.title
                    ? (event.competitionData.title.length > 30
                      ? event.competitionData.title.slice(0, 30) + '...'
                      : event.competitionData.title)
                    : ''
                }}
              </span>
              <!-- <span class="title-decoration"></span> -->
            </p>
            <v-row no-gutters class="modern-points-row">
              <!-- Individual Scores -->
              <v-col cols="12" md="4" class="modern-points-column" v-if="event.poster_type === 'Agency'"
                @click="agencyPoints(event.competitionId)">
                <div class="modern-points-header">
                  {{
                    event.points.agencyIndividualPoints?.name?.toUpperCase() ||
                    "No Agency"
                  }}
                </div>
                <div class="modern-points-value">
                  <v-icon color="#4A6BFF" class="modern-points-icon">mdi-star-circle-outline</v-icon>
                  <span>
                    {{ event.points.agencyIndividualPoints?.points || 0 }}
                  </span>
                </div>
                <div class="modern-points-label">INDIVIDUAL SCORE</div>
              </v-col>

              <v-col cols="12" md="4" class="modern-points-column" v-if="event.poster_type === 'Volunteer'"
                @click="volunteerPoints(event.competitionId)">
                <div class="modern-points-header">
                  {{
                    event.points.memberIndividualPoints?.name?.toUpperCase() ||
                    "No Member"
                  }}
                </div>
                <div class="modern-points-value">
                  <v-icon color="#4A6BFF" class="modern-points-icon">mdi-star-circle-outline</v-icon>
                  <span>
                    {{ event.points.memberIndividualPoints?.points || 0 }}
                  </span>
                </div>
                <div class="modern-points-label">INDIVIDUAL SCORE</div>
              </v-col>

              <!-- Team Scores -->
              <v-col cols="12" md="4" class="modern-points-column" @click="detailedView">
                <div class="modern-points-header">
                  {{
                    event.points.agencytotalpoints?.name?.toUpperCase() ||
                    "No Team"
                  }}
                </div>
                <div class="modern-points-value">
                  <v-icon color="#4A6BFF" class="modern-points-icon">mdi-account-group</v-icon>
                  <span>
                    {{ event.points.agencytotalpoints?.points || 0 }}
                  </span>
                </div>
                <div class="modern-points-label">TEAM SCORE</div>
              </v-col>

              <!-- All Rounder Scores -->
              <v-col cols="12" md="4" class="modern-points-column">
                <div class="modern-points-header">
                  {{
                    event.points.highestAgencyPointsInCompetition?.name?.toUpperCase() ||
                    "N/A"
                  }}
                </div>
                <div class="modern-points-value">
                  <v-icon color="#FFC107" class="modern-points-icon">mdi-crown</v-icon>
                  <!-- <v-icon color="amber darken-2" class="mr-1 trophy-icon">mdi-trophy</v-icon> -->
                  <span>
                    {{ event.points.highestAgencyPointsInCompetition?.points || 0 }}
                  </span>
                </div>
                <div class="modern-points-label">TOP PERFORMER</div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-hover>


      <!-- <v-card-text
       v-if="event.category != 'Individual' && event.points"
       class="d-flex justify-space-between w-100"
       @click="detailedView"
     >
     
       <div class="d-flex w-100">
         <div class="w-50">
           <span class="d-flex justify-space-between w-100">
             <span class="agency" v-if="event.points.highestAgency?.name">
               {{ event.points.highestAgency.name.toUpperCase() }}
             </span>
           </span>
           <span
             class="d-flex justify-space-between w-100"
             v-if="event.points.highestAgency?.points"
           >
             <span>{{ event.points.highestAgency.points }}</span>
           </span>
         </div>
         <div class="w-50">
           <span class="d-flex justify-space-between w-100">
             <span
               class="member"
               v-if="event.points.highestScoringMember?.name"
             >
               {{ event.points.highestScoringMember.name.toUpperCase() }}
             </span>
           </span>
           <span
             class="d-flex justify-space-between w-100"
             v-if="event.points.highestScoringMember?.points"
           >
             <span>{{ event.points.highestScoringMember.points }}</span>
           </span>
         </div>
         <div class="w-50">
           <span class="d-flex justify-space-between w-100">
             <span
               class="agency"
               v-if="event.points?.highestAgencyPointsInCompetition?.name"
             >
               {{
                 event.points.highestAgencyPointsInCompetition.name.toUpperCase()
               }}
             </span>
             <span v-else>No data available</span>
           </span>
           <span
             class="d-flex justify-space-between w-100"
             v-if="event.points?.highestAgencyPointsInCompetition?.points"
           >
             <span>{{
               event.points.highestAgencyPointsInCompetition.points
             }}</span>
           </span>
         </div>
       </div>
     </v-card-text> -->
      <v-card-text v-if="
        event.facebook_link ||
        event.instagram_url ||
        event.linkedin_link ||
        event.twitter_link
      " class="pb-0">
        Posted on:
        <span v-if="event.facebook_link" class="ml-2 url-button"
          @click="goToSocialLink(event.facebook_link)">@Facebook</span>
        <span v-if="event.instagram_link" class="ml-2 url-button"
          @click="goToSocialLink(event.instagram_link)">@Instagram</span>
        <span v-if="event.linkedin_link" class="ml-2 url-button"
          @click="goToSocialLink(event.linkedin_link)">@LinkedIn</span>
        <span v-if="event.twitter_link" class="ml-2 url-button"
          @click="goToSocialLink(event.twitter_link)">@Twitter</span>
      </v-card-text>
      <!-- <v-card-text
       class="flex-wrap px-0 d-flex w-100"
       v-observe-visibility="{
         callback: visibilityChanged,
         intersection: {
           threshold: 0.8
         },
         throttle: 600,
         throttleOptions: {
           leading: 'visible'
         }
       }"
       :style="
         limitedFiles.length == 0
           ? 'display: none'
           : limitedFiles.length != 1
           ? 'height: 450px;'
           : ''
       "
     >
     <div
     v-for="(file, index) in limitedFiles"
     :key="index"
     @click="onOpenCardView(index)"
     :class="fileClass(index)"
     class="position-relative"
   >
       <div v-if="file.type == 'image' && file.url" class="w-100 h-100">
         <v-img
           :src="file.url"
           cover
           loading="eager"
           width="100%"
           height="100%"
         />
       </div>
       <vue-plyr
         ref="plyr"
         :options="{
           autoplay: false,
           muted: true,
           autopause: true
         }"
         v-else-if="file.type == 'video' && file.url"
       >
         <video
           controls
           crossorigin
           playsinline
           id="videoElement"
           @canplay="updatePaused"
           @playing="updatePaused"
           @pause="updatePaused"
           @ended="onEnded"
         >
           <source :src="file.url" type="video/mp4" />
         </video>
       </vue-plyr>
       <div v-else>
         {{ file }}
       </div>
         <div
           v-if="event && event.files.length > 5 && index == 4"
           class="justify-center position-absolute white--text font-30 app-bold-font w-100 h-100 d-flex align-center absolute-center"
           style="background-color: #0004;"
         >
           +{{ event.files.length - 5 }}
         </div>
       </div>
     </v-card-text> -->
      <v-card-text>
        <v-carousel v-if="limitedFiles.length > 0" hide-delimiters height="450px" show-arrows show-arrows-on-hover
          @change="onCarouselChange" v-observe-visibility="{
            callback: visibilityChanged,
            intersection: {
              threshold: 0.8
            },
            throttle: 600,
            throttleOptions: {
              leading: 'visible'
            }
          }" :next-icon="currentCarouselIndex < limitedFiles.length - 1
            ? 'mdi-chevron-right'
            : ''
            " :prev-icon="currentCarouselIndex > 0 ? 'mdi-chevron-left' : ''" class="event-image">
          <v-carousel-item v-for="(file, index) in limitedFiles" :key="index" class="position-relative media-container">
            <!-- Image Display -->
            <div v-if="file.type === 'image' && file.url" class="w-100 h-100" @click="onOpenCardView(index)">
              <v-img :src="file.url" cover loading="eager" width="100%" height="100%" />
              <div class="badge badge-length" v-if="limitedFiles.length > 1">
                {{ index + 1 }}/{{ limitedFiles.length }}
              </div>
            </div>

            <!-- Video Display -->
            <div v-else-if="file.type === 'video' && file.url" class="w-100 h-100 video-container">
              <vue-plyr ref="plyr" :options="{
                autoplay: false,
                muted: true,
                autopause: true,
                controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
                ratio: '16:9'
              }" style="--plyr-video-wrapper-padding-top: 0;" @click.stop>
                <video controls crossorigin playsinline :poster="file.thumbnail || ''"
                  :data-poster="file.thumbnail || ''">
                  <source :src="file.url" type="video/mp4" />
                </video>
              </vue-plyr>
              <div class="badge post-count" v-if="limitedFiles.length > 1">
                {{ index + 1 }}/{{ limitedFiles.length }}
              </div>
            </div>

            <div v-else>
              {{ file }}
            </div>
          </v-carousel-item>
        </v-carousel>

      </v-card-text>
      <v-card-text v-if="event.text" class="pb-0 mt-2 mb-2 event-text" style="position: relative">
        <span class="text-block" v-if="text_collapsed" v-text="collapsed_text" v-linkified />
        <span v-else v-text="event.text" class="text-block" v-linkified />
        <span v-if="event.text.length > 275" class="url-button" @click="toggleTextCollapse" x-small
          style="position: absolute; right: 18px; bottom: 0; background: white">
          {{ text_collapsed ? "...see more" : "see less" }}
        </span>
      </v-card-text>
      <v-card-text class="pt-0" v-if="likeData && (likeData.comments || likeData.count)">
        <!-- <feed-event-reaction-details
         :data="likeData"
         :onComment="showComments"
         :_id="_id"
       /> -->
        <feed-event-reaction-details :data="likeData && typeof likeData === 'object' ? likeData : {}"
          :onComment="showComments" :_id="_id" />
      </v-card-text>

      <!-- <v-card-text class="pt-0">
       <event-feed-like-board
         :onLike="onLike"
         :liked="likeData ? likeData.liked : null"
       />
       <v-btn text color="grey" @click="editComments">
         <v-icon class="mr-3">mdi-comment-text-outline</v-icon>
         Comment
       </v-btn>
       <v-btn text color="blue" @click="shareOnFacebook">
         <v-icon class="mr-3">mdi-facebook</v-icon>
         Share on Facebook
       </v-btn>
       <v-btn text color="grey" @click="sharepost(event)">
         <v-icon class="mr-3">mdi-share-variant</v-icon>
         Share
       </v-btn>
     </v-card-text> -->

      <v-card-text class="px-0 pt-0">
        <div class="action-bar-wrapper">
          <div class="action-bar">
            <!-- Like -->
            <div class="action-item">
              <event-feed-like-board :onLike="onLike" :liked="likeData && typeof likeData.liked === 'string'
                ? likeData.liked
                : ''
                " class="like-action" />
            </div>

            <!-- Comment -->
            <div class="action-item" @click="editComments">
              <v-icon size="20">mdi-message-text-outline</v-icon>
              <span class="action-label">Comment</span>
            </div>

            <!-- Share -->
            <div class="action-item" @click="sharepost(event)">
              <v-icon size="20">mdi-share-outline</v-icon>
              <span class="action-label">Share</span>
            </div>

            <!-- Donate - Visible only on mobile -->
            <!-- <div
              class="action-item donate-item"
              v-if="event.category !== 'Individual' && $vuetify.breakpoint.xs"
              @click="donate"
            >
              <v-icon size="20">mdi mdi-currency-usd</v-icon>
              <span class="action-label actn-label-donate">Donate</span>
            </div> -->
          </div>
        </div>
      </v-card-text>

      <v-card-text v-if="commendable" class="flex-row d-flex">
        <feed-event-post-comment ref="feedEventComment" :_id="_id" :onPosted="onPostedComment"
          :total="likeData.comments" :commentId="commentId" @comment-deleted="handleCommentDeleted" />
      </v-card-text>
      <v-snackbar v-model="snackbar" style="z-index: 10001">
        {{ errorMessage }}
      </v-snackbar>
      <confirm-delete-dialog :deleteDialog="deleteDialog" :onClose="onCloseConfirmDelete" :onConfirm="onConfirmDelete"
        text="This action can not be undone. Are you sure do you want to delete the event?" :loading="loading" />
      <edit-event-dialog v-if="editDialog" :event="{ ...event }" :dialog="editDialog" :onUpdated="onUpdatedEvent"
        :onCloseDialog="onCloseEditDialog" />
      <report-event-dialog type="Event" :_id="_id" :dialog="reportDialog" :onClose="onCloseReportDialog"
        :onReported="onReported" v-if="reportDialog && _id" />
      <block-event-dialog :_id="_id" :dialog="blockDialog" :onClose="onCloseBlockDialog" :onBlocked="onBlocked"
        v-if="blockDialog && _id" />
      <event-card-viewer v-model="cardViewer" :event="event" :start-index="startIndex"
        v-if="event.files && event.files.length && cardViewer" />
      <feed-share-dialog :dialog="shareDialog" :onClose="onCloseShareDialog" :eventUrlData="this.eventUrlData" />
    </v-card>
    <v-card v-if="event && getReported && showReport" class="mb-4">
      <v-card-title>
        This event reported by you.<br />
        Reason: {{ getReported }}
      </v-card-title>
    </v-card>
    <v-card v-else-if="errorEvent">
      <v-card-title class="justify-center d-flex py-15">
        Invalid or deleted event
      </v-card-title>
    </v-card>
    <div v-if="imageModal" class="custom-modal" @click.self="closeImageModal">
      <div class="custom-modal-content">
        <img :src="selectedImage" alt="Image" class="custom-modal-image" />
      </div>
    </div>
    <!-- <v-carousel
   v-if="limitedFiles.length > 0"
   hide-delimiters
   height="450px"
   show-arrows-on-hover
 >
   <v-carousel-item
     v-for="(file, index) in limitedFiles"
     :key="index"
     class="position-relative"
   >
     <div v-if="file.type === 'image' && file.url" class="w-100 h-100">
       <v-img
         :src="file.url"
         cover
         loading="eager"
         width="100%"
         height="100%"
       />
     </div>
     <vue-plyr
       ref="plyr"
       :options="{
         autoplay: false,
         muted: true,
         autopause: true
       }"
       v-else-if="file.type === 'video' && file.url"
     >
       <video
         controls
         crossorigin
         playsinline
         id="videoElement"
         @canplay="updatePaused"
         @playing="updatePaused"
         @pause="updatePaused"
         @ended="onEnded"
       >
         <source :src="file.url" type="video/mp4" />
       </video>
     </vue-plyr>
     <div v-else>
       {{ file }}
     </div>
   </v-carousel-item>
 </v-carousel> -->
    <point-details-dialog :dialog="pointsDialog" :onClose="onClosePointsDialog" :event="event"
      :detailedPoints="detailedPoints || []" />
    <volunteer-scores-dialog :dialog="volunteerScoresDialog" :onClose="onClosePointsDialog"
      :competitionTitle="competitionTitle" :volunteerScores="volunteerScores" />
    <agency-scores-dialog-vue :dialog="agencyScoresDialog" :onClose="onClosePointsDialog" :agencyScores="agencyScores"
      :competitionTitle="competitionTitle" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import EditableAvatar from "@/components/EditableAvatar.vue";
import FeedEventPostComment from "./FeedEventPostComment.vue";
import EventFeedLikeBoard from "./EventFeedLikeBoard.vue";
import FeedEventReactionDetails from "./FeedEventReactionDetails.vue";
import ConfirmDeleteDialog from "@/components/common/ConfirmDeleteDialog.vue";
import EditEventDialog from "./EditEventDialog.vue";
import ReportEventDialog from "./ReportEventDialog.vue";
import BlockEventDialog from "./BlockEventDialog.vue";
import EventCardViewer from "./EventCardViewer.vue";
import FeedShareDialog from "./FeedShareDialog.vue";
import axios from "axios";
import PointDetailsDialog from "./PointDetailsDialog.vue";
import VolunteerScoresDialog from "./VolunteerScoresDialog.vue";
import AgencyScoresDialogVue from './AgencyScoresDialog.vue';
export default {
  components: {
    EditableAvatar,
    FeedEventPostComment,
    EventFeedLikeBoard,
    FeedEventReactionDetails,
    ConfirmDeleteDialog,
    EditEventDialog,
    ReportEventDialog,
    BlockEventDialog,
    EventCardViewer,
    FeedShareDialog,
    PointDetailsDialog,
    VolunteerScoresDialog,
    AgencyScoresDialogVue
  },
  props: {
    _id: {
      type: String
    },
    loadedData: {
      type: Function
    },
    showReport: {
      type: Boolean,
      default: false
    },
    showBlocked: {
      type: Boolean,
      default: false
    },
    eventIndex: {
      type: Number,
      default: 0
    },
    loadMoreEvents: {
      type: Function
    },
    liked: {
      type: [String, Object],
      default: ""
    },

    onDeleted: Function,
    commentId: String
  },
  data() {
    return {
      imageModal: false,
      selectedImage: null,
      loading: false,
      event: null,
      autoPlaying: true,
      videoElement: null,
      paused: null,
      atouched: false,
      errorMessage: null,
      snackbar: false,
      dropMenus: [
        { title: "Copy link to event", icon: "mdi-link-variant" },
        { title: "I don't want to see this", icon: "mdi-eye-off" },
        // { title: "Unfollow", icon: "mdi-close-circle" },
        { title: "Report", icon: "mdi-flag" }
      ],
      commendable: false,
      likeData: null,
      deleteDialog: false,
      eventUrlData: {},
      editDialog: false,
      reportDialog: false,
      blockDialog: false,
      shareDialog: false,
      text_collapsed: true,
      collapsed_text: "",
      errorEvent: false,
      cardViewer: false,
      startIndex: 0,
      limitedFiles: [],
      agencyName: "",
      avatarBorderColor: "none",
      avatarBorderStyle: "none",
      name: "",
      currentCarouselIndex: 0,
      pointsDialog: false,
      detailedPoints: null,
      volunteerScoresDialog: false,
      agencyScoresDialog: false,
      volunteerScores: null,
      agencyScores: null,
      competitionTitle: "",
      isPosterPrivate: false,

    };
  },
  metaInfo() {
    return {
      title: this.event ? this.event.poster.name : "Default Title",
      meta: [
        {
          name: "description",
          content: this.event ? this.event.description : "Default description"
        },
        {
          property: "og:title",
          content: this.event ? this.event.poster.name : "Default Title"
        },
        {
          property: "og:description",
          content: this.event ? this.event.description : "Default description"
        },
        {
          property: "og:image",
          content: this.event ? this.event.image : "default-image.jpg"
        },
        { property: "og:url", content: window.location.href }
      ]
    };
  },

  computed: {
    ...mapGetters({
      globalPlaying: "event/playing",
      profile: "auth/getProfile",
      profileType: "auth/getType"
    }),
    isPosterVolunteer() {
      return this.event?.poster?.type === "Volunteer";
    },

    // Computed property to check if we should show lock
    shouldShowLock() {
      return this.isPosterPrivate && this.isPosterVolunteer;
    },
    sharedUrl() {
      return window.location.href;
    },
    shareTitle() {
      return this.event ? this.event.poster.name : "Default Title";
    },

    getReported() {
      if (!this.event || !this.event.reported || !this.event.reported.length)
        return null;
      for (let i = 0; i < this.event.reported.length; i++) {
        if (this.event.reported[i]._id == this.profile._id)
          return this.event.reported[i].reason;
      }
      return null;
    },
    getBlocked() {
      if (!this.event || !this.event.blocked || !this.event.blocked.length)
        return null;
      for (let i = 0; i < this.event.blocked.length; i++) {
        if (this.event.blocked[i]._id == this.profile._id)
          return this.event.blocked[i].reason;
      }
      return null;
    },

    avatarStyles() {
      return {
        width: "60px",
        height: "60px",
        borderColor: this.avatarBorderColor,
        borderWidth: "4px",
        borderStyle: this.avatarBorderStyle,
        borderRadius: "50%",
        objectFit: "cover",
        "z-index": "1",
        "margin-right": "10px"
      };
    },
    avatarClasses() {
      return ["avatar", this.profile.midThumbnail ? "has-image" : "no-image"];
    }
  },
  methods: {
    ...mapActions({
      getEvent: "event/getEvent",
      setPlaying: "event/setPlaying",
      getLikeCount: "event/getLikeCount",
      like: "event/like",
      deleteEvent: "event/deleteEvent",
      getHtmlEvent: "event/getHtmlEvent",
      getCompetitionDetailedPoints: "competition/getCompetitionDetailedPoints",
      allVolunteerScores: "competition/allVolunteerScores",
      allAgencyScores: "competition/allAgencyScores"
    }),
    shareOnFacebook() {
      const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        this.sharedUrl
      )}&t=${encodeURIComponent(this.shareTitle)}`;
      window.open(
        shareUrl,
        "_blank",
        "noopener,noreferrer,width=600,height=400"
      );
    },
    onCarouselChange(index) {
      this.currentCarouselIndex = index;
    },
    visibilityChanged(isVisible, entry) {
      if (isVisible && entry.intersectionRatio > 0.5) {
        if (
          this.event.files &&
          this.event.files.length == 1 &&
          this.event.files[0].type == "video"
        ) {
          if (this.autoPlaying) this.$refs.plyr[0].player.muted = true;
          this.$refs.plyr[0].player.play();
          this.autoPlaying = false;
          this.atouched = true;
          this.setPlaying(this._id);
        }
        if (this.eventIndex == 3) {
          this.loadMoreEvents();
        }
      }
    },
    handleCommentDeleted() {
      // Decrement the comment count in likeData and ensure it doesn't go below zero
      if (this.likeData && typeof this.likeData.comments === 'number') {
        this.likeData.comments = Math.max(0, this.likeData.comments - 1);
      } else if (this.likeData) {
        // fallback if comments is undefined
        this.likeData.comments = 0;
      }
    },
    updatePaused(event) {
      this.videoElement = event.target;
      this.paused = event.target.paused;
    },
    onEnded() {
      console.log("ended");
    },
    editComments() {
      this.commendable = !this.commendable;
      if (this.commendable) {
        setTimeout(() => {
          this.$refs.feedEventComment.makeFocus();
        }, 200);
      }
    },
    detailedView() {
      if (this.event.category == "Competition") {
        if (
          this.event.points &&
          this.event.points.highestAgencyPointsInCompetition
        ) {
          const payload = {
            competition_id: this.event.points.highestAgencyPointsInCompetition
              .competition_id
          };
          this.getCompetitionDetailedPoints(payload)
            .then(response => {
              this.detailedPoints = response;
              this.pointsDialog = true;
            })
            .catch(error => {
              console.log("Error:", error);
              this.loading = false;
              if (!error.response) {
                console.log("Network or Unknown Error:", error);
              } else {
                this.showErrorMessage(error.response.data.message);
              }
            });
          this.pointsDialog = true;
        }
      }
    },
    volunteerPoints(competitionId) {
      this.loading = true;
      const payload = {
        competitionId: competitionId,
      };
      this.allVolunteerScores(payload)
        .then(response => {
          this.loading = false;
          this.volunteerScores = response.topScoresofVolunteers || [];
          this.competitionTitle = response.competitionTitle;
          this.volunteerScoresDialog = true;
        })
        .catch(error => {
          this.loading = false;
          if (error.response == undefined) {
            console.log(error);
          } else {
            this.showErrorMessage(error.response.data.message);
          }
        });
    },
    agencyPoints(competitionId) {
      this.loading = true;
      const payload = {
        competitionId: competitionId,
      };
      this.allAgencyScores(payload)
        .then(response => {
          this.loading = false;
          this.agencyScores = response.topScoresofAgency || [];
          this.competitionTitle = response.competitionTitle;
          this.agencyScoresDialog = true;
        })
        .catch(error => {
          this.loading = false;
          if (error.response == undefined) {
            console.log(error);
          } else {
            this.showErrorMessage(error.response.data.message);
          }
        });
    },
    donate() {
      this.$router.push({
        name: "donation-set-amount",
        query: { id: this.event.points.agencytotalpoints.agencyId }
      });
    },
    // Add this method to handle poster click
    handlePosterClick() {
      // Only check privacy for Volunteers
      if (this.isPosterPrivate && this.event.poster.type === "Volunteer") {
        // Show toast message
        if (this.$toast) {
          this.$toast.error("This profile is private and not accessible");
        } else {
          // Fallback
          this.showErrorMessage("This profile is private and not accessible");
        }
        return;
      }

      // If not private (or it's an Agency), navigate to profile
      if (this.event?.poster?._id && this.event?.poster?.type) {
        this.goToProfile(this.event.poster._id, this.event.poster.type);
      }
    },
    onClosePointsDialog() {
      this.pointsDialog = false;
      this.volunteerScoresDialog = false;
      this.agencyScoresDialog = false;
    },
    getHtmlEvent(params) {
      const devBaseURI = "https://akindervolunteer.com/backend";
      // const productionBaseURI = 'https://akindervolunteer.com/backend';
      const url = `${devBaseURI}/allHtml/eventHtml/get-event?_id=${params._id}`;
      return axios.get(url, { params });
    },
    sharepost(post) {
      this.shareDialog = true;
      this.eventUrlData = post;
      // this.getHtmlEvent({ _id: post._id })
      //   .then(response => {
      //     console.log("response1111", response.data);
      //     this.eventUrlData = response.data;
      //   })
      //   .catch(error => {
      //     console.log("Error:", error);
      //     this.loading = false;
      //     if (!error.response) {
      //       console.log("Network or Unknown Error:", error);
      //     } else {
      //       this.showErrorMessage(error.response.data.message);
      //     }
      //   });
    },
    showComments() {
      this.commendable = true;
    },
    onLike(type) {
      this.loading = false;
      this.like({ _id: this._id, type })
        .then(data => {
          this.loading = false;
          this.likeData = { ...this.likeData, ...data };
        })
        .catch(error => {
          this.loading = false;
          if (error.response == undefined) {
            console.log(error);
          } else {
            this.showErrorMessage(error.response.data.message);
          }
        });
    },
    getLiked() {
      this.loading = true;
      this.getLikeCount({ _id: this._id })
        .then(data => {
          this.loading = false;
          this.likeData = data;
        })
        .catch(error => {
          this.loading = false;
          if (error.response == undefined) {
            console.log(error);
          } else {
            this.showErrorMessage(error.response.data.message);
          }
        });
    },
    showErrorMessage(message) {
      this.errorMessage = message;
      this.snackbar = true;
      console.log(message);
    },
    onPostedComment() {
      if (this.likeData.comments) this.likeData.comments++;
      else this.likeData = { ...this.likeData, comments: 1 };
    },
    onSelectedMenu(item) {
      if (item.title === "Delete Post") {
        this.showDeleteDialog();
      } else if (item.title === "Copy link to event") {
        this.copyToClipboard(
          process.env.VUE_APP_WEB_URL +
          "/backend/allHtml/eventHtml/get-event?_id=" +
          this.event._id
        );
        this.snackbar = true;
        this.errorMessage = "Copied the URL";
      } else if (item.title === "Report") {
        this.reportDialog = true;
      } else if (item.title === "I don't want to see this") {
        this.blockDialog = true;
      }
    },
    showDeleteDialog() {
      this.deleteDialog = true;
    },
    showEditDialog() {
      this.editDialog = true;
    },
    onOpenCardView(index) {
      // if (
      //   this.event.files &&
      //   this.event.files.length &&
      //   (this.event.files.length > 1 || this.event.files[0].type == "image")
      // ) {
      //   this.showImageModal(this.event.files[index].url);
      //   this.startIndex = index;
      //   if (this.$refs.plyr) {
      //     for (let i = 0; i < this.$refs.plyr.length; i++) {
      //       this.$refs.plyr[i].player.pause();
      //     }
      //   }
      // }
      const file = this.event.files[index];
      if (file.type === 'image') {
        this.showImageModal(file.url);
        this.startIndex = index;
      }
    },
    // Add this to handle video player initialization
    initVideoPlayers() {
      this.$nextTick(() => {
        if (this.$refs.plyr) {
          this.$refs.plyr.forEach((player, index) => {
            // Ensure each player is properly initialized
            player.player.on('play', () => {
              // Pause all other players when one plays
              this.$refs.plyr.forEach((p, i) => {
                if (i !== index && !p.player.paused) {
                  p.player.pause();
                }
              });
            });
          });
        }
      });
    },
    copyToClipboard(textToCopy) {
      // navigator clipboard api needs a secure context (https)
      if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard api method'
        return navigator.clipboard.writeText(textToCopy);
      } else {
        // text area method
        let textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        // make the textarea out of viewport
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((res, rej) => {
          // here the magic happens
          document.execCommand("copy") ? res() : rej();
          textArea.remove();
        });
      }
    },
    onCloseConfirmDelete() {
      this.deleteDialog = false;
    },
    onConfirmDelete() {
      this.loading = true;
      if (this.$refs.plyr) {
        for (let i = 0; i < this.$refs.plyr.length; i++) {
          this.$refs.plyr[i].player.pause();
        }
      }
      setTimeout(() => {
        this.deleteEvent({ _id: this.event._id })
          .then(() => {
            this.loading = false;
            if (this.onDeleted) {
              this.onDeleted(this.event);
            }
          })
          .catch(error => {
            this.loading = false;
            if (error.response == undefined) {
              console.log(error);
            } else {
              this.showErrorMessage(error.response.data.message);
            }
          });
      }, 200);
    },
    fileClass(index) {
      if (this.limitedFiles.length == 1) return "w-100";
      if (this.limitedFiles.length == 2) return "half-screen";
      if (this.limitedFiles.length === 3 && index === 0) return "half-screen";
      if (index && this.limitedFiles.length == 3) {
        return "quater-screen";
      }
      if (this.limitedFiles.length == 4) return "quater-screen";
      if (this.limitedFiles.length > 4) {
        if (index < 2) return "quater-screen";
        else return "one-sixth-screen";
      }
      return "one-sixth-screen";
    },
    getTimeAgo(oldTimeStr) {
      const oldTime = Date.parse(oldTimeStr);
      const time = new Date();
      const different = (time.getTime() - oldTime) / 1000;
      const month = (different / 3600 / 24 / 30) | 0;
      const days = (different / 3600 / 24) % 30 | 0;
      const hours = (different / 3600) % 24 | 0;
      const mins = (different / 60) % 60 | 0;
      if (month == 1) return `1 month ago`;
      if (month) return `${month} months ago`;
      if (days == 1) return `1 day ago`;
      if (days) return `${days} days ago`;
      if (hours == 1) return `1 hours ago`;
      if (hours) return `${hours} hours ago`;
      if (mins == 1) return `1 min ago`;
      if (mins) return `${mins} min ago`;
      return `less than 1 min ago`;
    },
    getCollapsedText() {
      if (!this.event.text) {
        this.text_collapsed = false;
        return;
      }

      const full_text = this.event.text.trim();

      // Truncate the text to 275 characters
      if (full_text.length > 275) {
        this.collapsed_text = full_text.substring(0, 275) + "...";
        this.text_collapsed = true;
      } else {
        this.collapsed_text = full_text;
        this.text_collapsed = false;
      }
    },
    toggleTextCollapse() {
      this.text_collapsed = !this.text_collapsed;
    },
    onCloseEditDialog() {
      this.editDialog = false;
    },
    onCloseReportDialog() {
      this.reportDialog = false;
    },
    onCloseBlockDialog() {
      this.blockDialog = false;
    },
    onCloseShareDialog() {
      this.shareDialog = false;
    },
    onReported() {
      this.reportDialog = false;
      this.getData();
    },
    onBlocked() {
      this.blockedDialog = false;
      this.getData();
    },
    onUpdatedEvent(event) {
      this.editDialog = false;
      this.event = { ...event };
      if (event.files) {
        this.limitedFiles = event.files.slice(
          0,
          event.files.length > 5 ? 5 : event.files.length
        );
      }
    },
    showImageModal(url) {
      this.selectedImage = url;
      this.imageModal = true;
    },
    closeImageModal() {
      this.imageModal = false;
      this.selectedImage = null;
    },
    goToProfile(poster, type) {
      if (type == "Agency") {
        this.$router.push({
          name: "agency-profile-details",
          params: { id: poster }
        });
      } else if (type == "Volunteer") {
        this.$router.push({
          name: "volunteer-profile-details",
          params: { id: poster }
        });
      }
    },
    getData() {
      this.loading = true;
      this.getEvent({ _id: this._id })
        .then(event => {
          this.loading = false;
          this.event = event;

          // Check if poster is private - ONLY for Volunteers
          // Agencies don't have privacy settings like Volunteers
          const isOwnProfile = event.poster?._id === this.profile?._id;
          const posterType = event.poster?.type;
          const privacySetting = event.poster?.profile_share_privacy;

          // Only apply privacy check for Volunteers
          if (posterType === "Volunteer") {
            // Set isPosterPrivate - private if not Public AND not own profile
            this.isPosterPrivate = !isOwnProfile && privacySetting !== "Public";
          } else {
            // For Agencies, always allow access
            this.isPosterPrivate = false;
          }

          this.avatarBorderColor = this.event.poster.avatarColour || "none";
          this.avatarBorderStyle = this.event.poster.avatarColour
            ? "solid"
            : "none";
          if (event.files) {
            this.limitedFiles = event.files;
          }
          this.getCollapsedText();
          if (this.loadedData) this.loadedData(this._id);
          this.getLiked();
          if (this.commentId) this.commendable = true;
          if (this.event.poster._id == this.profile._id) {
            this.dropMenus = [
              { title: "Copy link to event", icon: "mdi-link-variant" },
              { title: "Delete Post", icon: "mdi-trash-can" }
            ];
          } else if (this.profileType == "Admin") {
            this.dropMenus = [
              { title: "Copy link to event", icon: "mdi-link-variant" },
              { title: "Delete Post", icon: "mdi-trash-can" }
            ];
          } else {
            this.dropMenus = [
              { title: "Copy link to event", icon: "mdi-link-variant" },
              { title: "I don't want to see this", icon: "mdi-eye-off" },
              { title: "Report", icon: "mdi-flag" }
            ];
          }
        })
        .catch(error => {
          this.loading = false;
          if (error.response == undefined) {
            console.log(error);
          } else {
            this.showErrorMessage(error.response.data.message);
            if (error.response.data.message == "event not found") {
              this.errorEvent = true;
            }
          }
        });
    },
    goToSocialLink(url) {
      window.open(url, "_blank");
    }
  },
  watch: {
    paused(newValue) {
      if (!this.atouched) {
        this.$refs.plyr[0].player.muted = false;
      }
      this.atouched = false;
      if (!newValue) {
        if (this.globalPlaying != this._id) {
          this.setPlaying(this._id);
        }
      } else {
        if (this.globalPlaying == this._id) {
          this.setPlaying("");
        }
      }
    },
    limitedFiles: {
      handler() {
        this.$nextTick(this.initVideoPlayers);
      },
      deep: true
    },
    globalPlaying(newValue) {
      if (newValue && this._id != newValue) {
        if (this.$refs.plyr && this.$refs.plyr[0]) {
          this.$refs.plyr[0].player.pause();
          this.atouched = true;
        }
      }
    }
  },
  mounted() {
    if (this._id) {
      this.getData();
    }
    // Initialize video players after data is loaded
    this.$nextTick(this.initVideoPlayers);
  }
};
</script>
<style scoped>
.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.action-item.donate-item {
  border: 2px solid #1976d2;
  border-radius: 21px;
  height: 24px;
  min-width: 103px;
  /* Changed from width to min-width */
  margin-top: 13px !important;
  margin-left: 14px;
  flex-shrink: 0;
  /* Prevent button from shrinking */
}

/* For mobile view */
@media (max-width: 600px) {
  .action-item.donate-item {
    margin-left: 8px;
    min-width: 90px;
  }
}

div :deep(.plyr video) {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

div :deep(.plyr__video-wrapper) {
  padding-top: 56.2%;
}

.text-block {
  white-space: pre-line;
  color: black;
  overflow: hidden;
  display: block;
}

.half-screen {
  width: 100%;
  height: 50%;
}

.quater-screen {
  width: 50%;
  height: 50%;
}

.one-sixth-screen {
  width: 33.33%;
  height: 50%;
}

.comptetion {
  font-size: 12px;
  color: #000;
  font-weight: 600;
  margin-left: -16px;
}

.agency {
  font-size: 14px;
  color: #000;
  font-weight: 600;
}

.member {
  font-size: 12px;
  color: #000;
  font-weight: 600;
  margin-left: -16px;
}

.donate-btn {
  font-size: 12px;
  color: #fff;
  border-radius: 16px;
}

.avatarClasses .avatarStyles {
  border-radius: 50%;
  object-fit: cover;
  width: 99px;
  height: 99px;
}

.avatar-img {
  border-radius: 50%;
  height: 53px;
  width: 53px;
}

.custom-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.custom-modal-content {
  position: relative;
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 800px;
  width: 100%;
  text-align: center;
}

.custom-modal-image {
  max-width: 100%;
  height: auto;
}

.badge-length {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 5px 10px;
  border-radius: 12px;
  font-size: 12px;
}

.mb-4.event-card.v-card.v-sheet.theme--light {
  border-radius: 12px;
}

.v-window.event-image.v-item-group.theme--dark.v-window--show-arrows-on-hover.v-carousel {
  border-radius: 20px;
}

.v-card__title.flex-row.d-flex.mr-9.avatar-event-icon {
  padding: 25px 5px 5px 20px;
}

button.menu-btn.v-btn.v-btn--icon.v-btn--round.theme--light.v-size--default {
  padding: 17px 19px 0px 0px;
}

.v-card__text.pb-0.event-text {
  padding: 5px 20px 10px 24px;
  text-align: justify;
}

button.donate-btn.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--dark.v-size--default.primary {
  margin: 6px 0px 0px 290px;
}

.action-bar-wrapper {
  padding: 0 8px;
}

.action-bar {
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-top: 1px solid #eee;
  padding: 8px 0;
}

.action-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.action-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.action-label {
  margin-left: 6px;
  font-size: 0.875rem;
  color: #555;
}

.donate-item .v-icon {
  color: #1976d2;
  /* Red color for donate icon */
}

.like-action {
  display: flex;
  align-items: center;
}

/* Improved spacing and alignment */
.v-col {
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* Golden trophy effect */
.trophy-icon {
  color: #ffd700 !important;
  text-shadow: 0 0 8px rgba(255, 215, 0, 0.7);
  animation: sparkle 2s infinite alternate;
}

@keyframes sparkle {
  0% {
    transform: scale(1);
    text-shadow: 0 0 8px rgba(255, 215, 0, 0.7);
  }

  50% {
    transform: scale(1.1);
    text-shadow: 0 0 12px rgba(255, 215, 0, 0.9);
  }

  100% {
    transform: scale(1);
    text-shadow: 0 0 8px rgba(255, 215, 0, 0.7);
  }
}

/* Consistent text sizing */
.text-h6 {
  font-size: 1.1rem;
  text-align: center;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .v-col {
    border-right: none !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    padding-bottom: 16px !important;
  }

  .v-col:last-child {
    border-bottom: none !important;
  }
}

.action-item.donate-item {
  border: 2px solid #1976d2;
  border-radius: 21px;
  height: 24px;
  width: 103px;
  margin-top: 8px;
  margin-left: 14px;
}

.actn-label-donate {
  margin-left: 6px;
  font-size: 0.875rem;
  color: #1976d2;
  font-weight: 600;
}


.modern-competition-card {
  font-family: 'Inter', sans-serif;
}

.modern-points-card {
  background: white;
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #EDF2F7;
  width: 80%;
  margin-left: 8%;
}

.modern-points-card-hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
  border-color: #E2E8F0;
}

.modern-points-row {
  padding: 8px 0;
}

.modern-points-column {
  padding: 12px;
  position: relative;
}

.modern-points-column:not(:last-child)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 60%;
  width: 1px;
  background: #E2E8F0;
}

.modern-points-header {
  font-size: 0.75rem;
  font-weight: 600;
  color: #4A6BFF;
  text-align: center;
  margin-bottom: 12px;
  letter-spacing: 0.5px;
}

.modern-points-value {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 8px;
}

.modern-points-value span {
  font-size: 1.25rem;
  font-weight: 700;
  color: #2D3748;
}

.modern-points-icon {
  font-size: 1.5rem;
}

.modern-points-label {
  font-size: 0.6875rem;
  color: #718096;
  text-align: center;
  font-weight: 500;
  letter-spacing: 0.5px;
}

@media (max-width: 959px) {
  .modern-points-column {
    border-bottom: 1px solid #EDF2F7;
    padding: 16px 0;
  }

  .modern-points-column:last-child {
    border-bottom: none;
  }

  .modern-points-column::after {
    display: none;
  }
}

.title-container {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 24px;
}

.modern-competition-title {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  position: relative;
  text-align: center;
  line-height: 1.3;
  padding-bottom: 8px;
}

.modern-competition-title .title-text {
  position: relative;
  z-index: 2;
  background: linear-gradient(90deg, #4F46E5 0%, #10B981 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.modern-competition-title .title-decoration {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #4F46E5 0%, #10B981 100%);
  border-radius: 3px;
}

/* @media (min-width: 768px) {
  .modern-competition-title {
    font-size: 20px;
  }
} */


.media-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
  height: 100%;
  width: 100%;
}

.video-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.video-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.7);
}

.thumbnail-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
}

.thumbnail-img {
  filter: blur(2px);
}

.plyr--video {
  width: 100%;
  height: 100%;
}

.plyr__video-wrapper {
  height: 100%;
  width: 100%;
  position: relative;
}

/* Ensure video fills container while maintaining aspect ratio */
.plyr__video-wrapper video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #000;
}

/* Badge positioning */
.badge.post-count,
.badge.badge-length {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 5px 10px;
  border-radius: 12px;
  font-size: 12px;
  z-index: 2;
}

/* Center play button */
.plyr__control--overlaid {
  background: rgba(0, 0, 0, 0.8);
  border: 2px solid #fff;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .plyr--full-ui .plyr__control--overlaid {
    width: 50px;
    height: 50px;
  }

  .plyr__control--overlaid svg {
    width: 20px;
    height: 20px;
  }

  .v-carousel {
    height: 350px !important;
  }
}

/* Fix for plyr controls visibility */
:deep(.plyr--full-ui) {
  width: 100%;
  height: 100%;
}

:deep(.plyr__controls) {
  background: rgba(0, 0, 0, 0.7);
}

:deep(.plyr__control:hover) {
  background: rgba(255, 255, 255, 0.2);
}

:deep(.plyr__video-wrapper) {
  padding-top: 0 !important;
  height: 100%;
}

.video-container {
  position: relative;
  width: 100%;
  height: 100%;
}

:deep(.plyr) {
  height: 100%;
  width: 100%;
}

:deep(.plyr video) {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Prevent carousel from capturing video player clicks */
.video-container {
  pointer-events: auto;
}

/* Ensure video player takes full space */
:deep(.plyr) {
  width: 100%;
  height: 100%;
}

/* Prevent carousel from interfering with video controls */
:deep(.plyr__controls) {
  pointer-events: auto;
}

/* Make sure video element is properly sized */
:deep(.plyr video) {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Add styles for lock overlay */
.lock-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.avatar {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  flex-shrink: 0;
}

.avatar-img {
  border-radius: 50%;
  height: 53px;
  width: 53px;
  object-fit: cover;
}
</style>
